// Import toggle switch component
import  ToggleSwitch  from "global/components/ToggleSwitch";

import "global/components/CreateToggleFilters.css";



// This renders all filter groups using toggle switches
const CreateToggleFilters = ({

    // This contains all unique filter options grouped by key
    uniqueFilterOptions = {},

    // This contains the currently included values for each filter group
    selectedFilters = {},

    // This contains the default included values for each filter group
    defaultFilters = {},

    // This contains the visible labels for each filter group
    filterLabels = {},

    // This toggles a single value on or off inside a filter group
    toggleFilterValue,

    // This sets all values in a filter group to included
    setFilterGroupAllOn,

    // This sets all values in a filter group to excluded
    setFilterGroupAllOff,

    // This resets a filter group back to its default included values
    resetFilterGroup,

    // So we can clear any selected table rows when changing filters
    setSelectedRows = () => {},

}) => (


    Object.entries(uniqueFilterOptions).map(([key, values]) => {

        // Get the currently included values for this filter group
        const selectedValues = selectedFilters[key] || [];

        /*
        // Get the default included values for this filter group
        const defaultValues = defaultFilters[key] || [];
        
        // Check whether all values are currently included
        const isAllOn = values.length > 0 && selectedValues.length === values.length;

        // Check whether no values are currently included
        const isAllOff = selectedValues.length === 0;

        // Check whether the current state matches the default state
        const isDefaultState =
            values.length === 0
                ? true
                : values.every((value) => {
                    return defaultValues.includes(value) === selectedValues.includes(value);
                });
        */

        return (

            <div key={key} className="filters__filter-group">

                <div className="filters__group-header">

                    {/* This is the filter title */}
                    <p className="filters__label">{filterLabels[key]}</p>

                    {/* These are the compact group action buttons */}
                    <div className="filters__group-actions">

                        <div
                            title="Select All"
                            onClick={() => {
                                setSelectedRows([]);
                                setFilterGroupAllOn(key, values);
                            }}
                            className="filters__action-button"
                        >
                            ☑
                        </div>

                        <div
                            title="Deselect All"
                            onClick={() => {
                                setSelectedRows([]);
                                setFilterGroupAllOff(key, values);
                            }}
                            className="filters__action-button"
                        >
                            ☐
                        </div>

                        {/* Taken out - they can select what they want
                        <div
                            title="Reset to Default"
                            onClick={() => {
                                setSelectedRows([]);
                                resetFilterGroup(key);
                            }}
                            className="filters__action-button"
                        >
                            ↻
                        </div>
                        */}
                    </div>

                </div>

                {/* These are the individual toggle options */}
                <div className="filters__toggle-list">

                    {values.map((val) => {

                        // Check whether this value is currently included
                        const isChecked = selectedValues.includes(val);

                        return (

                            <div key={val} className="filters__toggle-row">
                               
                                {/* This is the include or exclude toggle */}
                                <ToggleSwitch
                                    size="xs"
                                    value={isChecked}
                                    onChange={() => {
                                        setSelectedRows([]);
                                        toggleFilterValue(key, val);
                                    }}
                                    label={val}
                                    labelPosition="right"
                                    labelClassName="filters__toggle-text"
                                />

                            </div>

                        );

                    })}

                </div>

            </div>

        );

    })

);



// Export the component
export default CreateToggleFilters;